const darkTheme = {
    global: {
        text: "#eee",
        background: "#2a2a2a",
        border: "#434343"
    },
    sidebar: {
        bg: "#1f1f1f",
        text: "#ddd",
        icon: "#aaa",
        select: "#ec1c2a",
        bgSelect:"#3a3a3a",
        borderTopAB: "rgba(145, 158, 171, 0.3)",
        bt: "#3a3a3a",
        bR: "#3a3a3a",
        avatar: "#eee",
    },
    sidebarOrgSetting: {
        bg: "#1f1f1f",
        text: "#ddd",
        icon: "#aaa",
        select: "#ec1c2a",
        bgSelect: "#3a3a3a",
    },
    sidebarFolderSetting: {
        bg: "#1f1f1f",
        text: "#ddd",
        icon: "#aaa",
        bgSelect: "#3a3a3a",
        copy: "#aaa",
        select: "#ec1c2a",
    },
    headbar: {
        btnMenu: '#aaa'
    },
    folders: {
        text: "#aaa",
        textHover: "#fff",
        folderCardBg: "#333",
        folderCardText: "#ddd",
        folderCardSubText: "#aaa",
        folderCardIcon: "#aaa",
        folderCardBorder: "#3a3a3a",
        itemHover: "#3A3A3D",
    },
    folderDetail: {
        curFol: "#eee",
        bgColorHeader: "#2a2a2a",
        text : "#eee",

        //Badge
        borderColor: "#fff",
        colorTabDefault: '#d9d9d9',
        bgColorCountNonSelected: '#fff',

        //Search
        bgSearch: '#1f1f1f',
        borderSearch: '#434343',

        //Footer
        bgFooter: '#2a2a2a',
    },
    SubmissionDrawer: {
        text: "#ddd",  
        border: "#434343",
        hover: "#3a3a3a",
        iconCheck: "#ddd",
    },
    submissionData: {
        text: "#ddd",
        btnRatio: "#1f1f1f",
        bgTopbar: '#1f1f1f',
        btnTopbar: '#eee',
        datapointLabel: '#eee',

        bgDocumentImage: '#434343',

        //Table Footer
        bgTableFooter: '#1f1f1f',
        iconDelete: '#ddd',
        borderTable: "#434343",
    },
    pricing: {
        bgCardPrice: "#333",
        text: "#ddd",
    },
    review: {
        text: "#ddd",
        bgField: "#1a1a1a",
        bgMain: "#2a2a2a",
        btn: "#fff",
        bgDiff: "#1a1a1a",
        borderDiff: "#434343",
    },
    statistic: {
        text: "#eee",
        background: "#2a2a2a",
        border: 'rgba(145, 158, 171, 0.3)'
    },

// AtnD Config Theme    
    pagination: {
        bgColorDefault: "#2c2c2c", 
        borderColorDefault: '#434343', 
        colorTextDefault: '#d9d9d9', 
        
        bgColorHover: '#3a3a3a', 
        borderColorHover: '#ec1c2a', 
        colorTextHover: '#ec1c2a', 

        bgColorActive: '#ec1c2a', 
        colorTextActive: '#fff', 
    },
    table: {
        bgColor: '#1f1f1f',             
        bgColorHeader: '#262626',       
        borderColor: '#434343',         

        colorTextHeader: '#d9d9d9',     
        colorTextBody: '#d9d9d9',

        bgColorHover: '#333333',        
        bgColorStripe: '#1f1f1f', 
        
        bgSkipRow: '#7e7e7eff',
        bgColorSelected: "#84373c"

    },
    input: {
        bgColorDefault: '#1f1f1f',      
        borderColorDefault: '#434343',  
        colorTextDefault: '#d9d9d9',    

        colorPlaceholder: '#8c8c8c', 

        borderColorFocus: '#ec1c2a',     
        boxShadowFocus: '0 0 0 2px rgba(24, 144, 255, 0.2)',
        
        bgColorDisabled: '#262626',      
        colorTextDisabled: '#8c8c8c', 
    },
    drawer: {
        bgColor: '#2a2a2a',
        bgColorHeader: '#000',
        colorText: '#d9d9d9',
        colorCloseIcon: '#d9d9d9',
        borderColor: '#434343',
    },
    select: {
        bgColorDefault: '#1f1f1f',      
        borderColorDefault: '#434343',  
        colorTextDefault: '#d9d9d9',    

        colorPlaceholder: '#8c8c8c', 

        borderColorFocus: '#ec1c2a',     
        
        bgColorDropdown: '#262626',      
        bgColorOptionHover: '#333333',   
        bgColorOptionSelected: '#000000ff',
        bgSelectedItem: '#000000ff',
        colorTextOptionSelected: '#000000',
    },
    btn: {
        defaultBgColor: '#262626',
        defaultTextColor: '#d9d9d9',
        defaultBorderColor: '#434343',
        defaultHoverBgColor: '#3a3a3a',
        defaultHoverBorderColor: '#ec1c2a',
        defaultHoverTextColor: '#ec1c2a',

        primaryBgColor: '#ec1c2a',
        primaryTextColor: '#fff',
        primaryBorderColor: '#ec1c2a',
        primaryHoverBgColor: '#ef4954',
        primaryHoverBorderColor: '#ef4954',

        textHoverBgColor: '#3a3a3a',
    },
    dropdown: {
        bgColorDropdown: '#262626',      
        colorTextDefault: '#d9d9d9',
        bgColorOptionHover: '#333333',   
    },
    spin: {
        colorBgContainer: '#2a2a2a',
    },
    datepicker: {
        bgColorDefault: '#1f1f1f',      
        borderColorDefault: '#434343',  
        colorTextDefault: '#d9d9d9',    
        colorPlaceholder: '#8c8c8c', 
        borderColorFocus: '#ec1c2a',     
        bgColorDisabled: '#262626',      
        colorTextDisabled: '#8c8c8c', 
        separatorColor: '#8c8c8c',
        panelBg: '#1f1f1f',
        bgHover: '#434343', 
    },
    popover: {
        bgColor: '#1a1a1a',
        colorText: '#ddd',
        borderColor: '#434343',
        titleBottomBorder: '#303030',
        hover: '#3a3a3a',
    },
    modal: {
        bgColor: '#1f1f1f',      
        colorText: '#d9d9d9',    
        borderColor: '#434343',  
        maskBg: 'rgba(0, 0, 0, 0.7)',
        closeIconColor: '#8c8c8c',
    },
}

export default darkTheme;